import {
	connect
} from 'react-redux'
import OrdersComponent from '../components/OrdersComponent.jsx';
import {
	closeOrderModal
} from '../actions';

const mapStateToProps = (state) => ({
	showAddOrderModal: state.getIn(['orderReducer', 'showAddOrderModal']),
	showEditOrderModal: state.getIn(['orderReducer', 'showEditOrderModal']),
	showEditOrderDetailModal: state.getIn(['orderReducer', 'showEditOrderDetailModal']),
	showViewOrderModal: state.getIn(['orderReducer', 'showViewOrderModal']),
})

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => {
		dispatch(closeOrderModal());
	},
})

const OrdersContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(OrdersComponent)

export default OrdersContainer;


// WEBPACK FOOTER //
// ./src/containers/OrdersContainer.jsx